import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ebeihilfe-trash-svg',
  templateUrl: './trash-svg.component.svg',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class TrashSvgComponent {}
